var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDurationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 8.73136V3.45455C15.3 2.99644 15.1209 2.55711 14.8021 2.23318C14.4833 1.90925 14.0509 1.72727 13.6 1.72727H10.047C9.69 0.725455 8.755 0 7.65 0C6.545 0 5.61 0.725455 5.253 1.72727H1.7C0.765 1.72727 0 2.50455 0 3.45455V15.5455C0 16.0036 0.179107 16.4429 0.497918 16.7668C0.81673 17.0907 1.24913 17.2727 1.7 17.2727H6.8935C7.9645 18.3436 9.4265 19 11.05 19C14.3395 19 17 16.2968 17 12.9545C17 11.305 16.354 9.81955 15.3 8.73136ZM7.65 1.72727C8.1175 1.72727 8.5 2.11591 8.5 2.59091C8.5 3.06591 8.1175 3.45455 7.65 3.45455C7.1825 3.45455 6.8 3.06591 6.8 2.59091C6.8 2.11591 7.1825 1.72727 7.65 1.72727ZM2.55 5.18182H12.75V6.90909H2.55V5.18182ZM5.168 13.8182H2.55V12.0909H5.168C5.1255 12.3759 5.1 12.6609 5.1 12.9545C5.1 13.2482 5.1255 13.5332 5.168 13.8182ZM2.55 10.3636V8.63636H6.8935C6.375 9.12864 5.984 9.71591 5.678 10.3636H2.55ZM11.05 17.2727C8.704 17.2727 6.8 15.3382 6.8 12.9545C6.8 10.5709 8.704 8.63636 11.05 8.63636C13.396 8.63636 15.3 10.5709 15.3 12.9545C15.3 15.3382 13.396 17.2727 11.05 17.2727ZM11.475 13.1705L13.906 14.63L13.2685 15.6836L10.2 13.8182V9.5H11.475V13.1705Z",
    fill: "#1C3D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDurationIcon);
export default __webpack_public_path__ + "static/media/duration-icon.ba888c880e58780c2bdf2be214084f0f.svg";
export { ForwardRef as ReactComponent };